<template>
	<div class="modal-box">
		<div class="modal-cover back" v-if="modalData.isShowModal" @click="closeModal"></div>
		<transition name="el-fade-in-linear">
			<div class="modal-content" v-if="modalData.isShowModal">
				<div class="modal-head back">
					<slot v-if="modalData.modalType === 'editChaptingDescription' || modalData.modalType === 'addChapting'" name="header_1"></slot>
					<slot v-else-if="modalData.modalType === 'toggleAvatar' || modalData.modalType === 'insertDialog'" name="header_3"></slot>
					<slot v-else-if="modalData.modalType === 'delDialog'" name="header_4"></slot>
					<slot v-else name="header_2"></slot>
				</div>
				<div class="modal-main" :class="{insertDialog:modalData.modalType === 'insertDialog'}">
					<!-- Edit chapting description -->
					<template v-if="modalData.modalType === 'editChaptingDescription' || modalData.modalType === 'addChapting'">
						<Chapting><h2 slot="title">Chapter description</h2></Chapting> 
					</template>
					<!-- open preview tips (if words'slength > 800) -->
					<template v-else-if="modalData.modalType === 'reviewTips'">
						<Tips>
							<p class="tips-text" slot="tips-text">Operate Failed-The total quantity of letters cannot be less than 800</p>
						</Tips> 
					</template>
					<!-- Edit dislog info -->
					<template v-else-if="modalData.modalType === 'insertDialog'">
						<MDialog></MDialog>
					</template>
					<!-- Delete Dialog -->
					<template v-else-if="modalData.modalType === 'delDialog'">
						<ConfirmDelete :modalData="modalData">
							<p class="tips-text" v-if="modalData.delType === 'dialog'" slot="tip-text">Are you sure to delete the dialog?</p>
							<p class="tips-text" v-if="modalData.delType === 'book'" slot="tip-text">Are you sure to delete the book?</p>
							<p class="tips-text" v-if="modalData.delType === 'chapter'" slot="tip-text">Are you sure to delete the chapter?</p>
						</ConfirmDelete>
					</template>
					<!-- Delete Dialog -->
					<template v-else-if="modalData.modalType === 'toggleAvatar'">
						<Roles></Roles>
					</template>
				</div>
				<div class="foot_close" @click="closeModal">
					<div class="close_img"></div>
				</div>
			</div>
		</transition>
	</div>

</template>

<script>
	import { mapState, mapActions, mapMutations} from 'vuex'
	import Chapting from '@/components/modal/Chapting.vue'
	import MDialog from '@/components/modal/Mdialog.vue'
	import Tips from '@/components/modal/Tips.vue'
	import ConfirmDelete from '@/components/modal/ConfirmDelete.vue'
	import Roles from '@/components/modal/Roles.vue'
	export default {
		name: "modal",
		components: {
			Chapting,
			MDialog,
			Tips,
			ConfirmDelete,
			Roles
		},
		props: ['modalData'],
		methods: {
			closeModal() {
				if (this.modalData.modalType === 'toggleAvatar' || this.modalData.modalType === 'insertDialog' || this.modalData.delType === 'dialog') {
					this.$store.commit('dialog/closeModalFn')
					return
				} 
				if (this.modalData.delType === 'chapter') {
					this.$store.commit('bookItem/closeModalFn')
					return
				}
				if (this.modalData.delType === 'book') {
					this.$store.commit('home/closeModalFn')
					return
				}
				this.$store.dispatch('bookItem/cancleModal')
			}
		}
	}
</script>

<style lang="scss">
	.modal-box {
		position: relative;
		color: #2e2c2d;
		font-size: 16px;
		.modal-cover {
			background: rgba(0, 0, 0, 0.8);
			position: fixed;
			z-index: 200;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
		}
		.modal-tips {
			p.tips-text {
				font-size: 16px;
				line-height: 24px;
				color: #6f6f6f;
				text-align: center;
			}
		}
		.modal-content {
			position: fixed;
			top: 50%;
			width: 312px;
			left: 50%;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			z-index: 300;
			margin-left: -156px;
			margin-top: -150px;    
			.modal-head {
				background-size: 300% 100%;
				background-image: linear-gradient(to right, #fc6076, #ff8044, #ef9d43, #e75516);
				width: 312px;
				height: 43px;
				color: #fff;
				font-size: 20px;
				font-weight: bold;
				display: flex;
				justify-content: center;
				align-items: center;
				border-top-right-radius: 10px;
			}
		
			.modal-main {
				background: #ffffff;
				justify-content: center;
				align-content: center;
				width: 312px;
				padding: 20px 20px 30px;
				border-bottom-left-radius: 10px;
				&.insertDialog {
					padding: 20px 10px 30px;
				}
				.ok-btn {
					margin: 20px 0 0;
					display: flex;
					justify-content: center;
					.el-button {
						font-weight:bold;
					}
					.el-button.el-button--primary {
						width: 90px;
						background-color: #fa4863;
						background-size: 300% 100%;
						border-radius: 50px;
						font-size: 16px;
						height: 40px;
						line-height: 40px;
						padding: 0;
					}
				}
			}
		
			.foot_close {
				display: flex;
				justify-content: center;
				align-content: center;
				margin-top: 15px;
				transition: margin-top 0.5s;
				-moz-transition: margin-top 0.5s;
				/* Firefox 4 */
				-webkit-transition: margin-top 0.5s;
				/* Safari and Chrome */
				-o-transition: margin-top 0.5s;
				/* Opera */
				&:hover {
					margin-top: 10px;
					cursor: pointer;
				}
		
				.close_img {
					background-image: url("../assets/bg_close.png");
					background-size: cover;
					width: 30px;
					height: 30px;
				}
			}
		}
	}
</style>
